import React, { FunctionComponent } from "react";
import {
  Breadcrumbs,
  Link,
  Step,
  StepLabel,
  Typography
} from "@material-ui/core";
import * as ReactRouter from "react-router-dom";
import Stepper from "@material-ui/core/Stepper";
import { State } from "../types";
import useStyles from "../styles";
import moment from "moment";

interface WrapperProps {
  state: State;
}

export const Wrapper: FunctionComponent<WrapperProps> = ({
  state,
  children
}) => {
  const classes = useStyles();
  const getStepIndex = () => {
    switch (state.type) {
      case "START":
      case "STARTING":
        return 0;
      case "GATHER":
        return 1;
      case "CONFIRM":
      case "CONFIRM_DIALOG":
      case "SAVING":
        return 2;
      case "DONE":
      case "CANCELLING":
      case "OPENING_BOXES":
        return 3;
      default:
        return -1;
    }
  };

  if (
    state.type === "INITIAL" ||
    state.type === "LOAD_ORDER" ||
    state.type === "NOT_ALLOWED" ||
    state.type === "UNEXPECTED_ERROR"
  ) {
    return <>{children}</>;
  }

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb" className={classes.breadCrumb}>
        <Link color="inherit" component={ReactRouter.Link} to="/stores">
          Stores
        </Link>
        <Link
          color="inherit"
          component={ReactRouter.Link}
          to={`/stores/${state.order.store.id}/user-orders`}
        >
          Orders
        </Link>
        <Typography color="textPrimary">
          {moment(state.order.created).format("YYYY-MM-DD HH:mm")}
        </Typography>
      </Breadcrumbs>
      <Stepper activeStep={getStepIndex()} alternativeLabel>
        <Step key={0}>
          <StepLabel>Start</StepLabel>
        </Step>
        <Step key={1}>
          <StepLabel>Gather</StepLabel>
        </Step>
        <Step key={2}>
          <StepLabel>Confirm</StepLabel>
        </Step>
        <Step key={3}>
          <StepLabel>Done</StepLabel>
        </Step>
      </Stepper>
      {children}
    </>
  );
};
